module.exports = __webpack_public_path__ + "static/media/Success.4c8fd343.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Toaster/Success.svg
// module id = 4357
// module chunks = 1